"use client";

import { useTransition } from "react";
import { useQueryClient } from "@tanstack/react-query";

import { stopImpersonationAction } from "@/app/actions/super-admin";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Eye, X } from "lucide-react";

interface ImpersonationBannerProps {
  storeName?: string;
}

export function ImpersonationBanner({ storeName }: ImpersonationBannerProps) {
  const [isPending, startTransition] = useTransition();
  const queryClient = useQueryClient();

  function handleStop() {
    startTransition(async () => {
      try {
        // 🔴 SAIR da impersonação também TROCA a loja ativa — é o terceiro caminho, junto do
        // `store-switcher` e do `impersonate-button`, e era o único sem esta linha.
        //
        // `stopImpersonationAction` apaga o cookie `impersonation_store_id` e faz `redirect` —
        // navegação SOFT. O `QueryClient` vive no layout RAIZ (`src/app/layout.tsx`) e sobrevive;
        // nenhuma `queryKey` do dashboard carrega o `storeId`; o `staleTime` é de 5 min. Sem o
        // `clear()`, o admin sai da loja do lojista levando o cache dela.
        //
        // O `clear()` vem ANTES da ação de propósito: depois dela o servidor já redirecionou.
        queryClient.clear();
        await stopImpersonationAction();
        // Redirect happens on server, but we can toast here if needed before unload
        toast.success("Saindo do God Mode...");
      } catch (e) {
        toast.error("Erro ao sair.");
      }
    });
  }

  return (
    <div className="bg-amber-500 text-white px-4 py-2 flex items-center justify-between shadow-md">
      <div className="flex items-center gap-2">
        <Eye className="h-4 w-4" />
        <span className="text-sm font-medium">
          God Mode Ativo: Você está visualizando a loja <strong>{storeName || "..."}</strong>
        </span>
      </div>
      <Button
        variant="secondary"
        size="sm"
        onClick={handleStop}
        disabled={isPending}
        className="h-7 text-xs bg-card text-amber-600 hover:bg-amber-100 border-0 disabled:opacity-50"
      >
        {isPending ? "Saindo..." : "Sair do God Mode"}
      </Button>
    </div>
  );
}
